import { custom, success } from "./utilities";
import { candidateConstants, globalConstants } from "../../constants";
import { candidateService } from "../../services/candidate.services";
import { ToastifyService } from "../../services/toastify.services";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION
};

export const getAllCandidate = (gridState, projectId = 0) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .getAll(gridState, projectId)
      .then((response) => {
        dispatch(success(response, candidateConstants.GET_CANDIDATES));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getCandidateById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .getById(id)
      .then((response) => {
        dispatch(success(response, candidateConstants.GET_CANDIDATE_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteCandidateById = (id, projectId = 0) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllCandidate(gridData, projectId));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createCandidate = (data, projectId = 0, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .create(data)
      .then((response) => {
        dispatch(getAllCandidate(gridData, projectId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateCandidate = (data, projectId = 0, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .update(data)
      .then((response) => {
        dispatch(getAllCandidate(gridData, projectId));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllCandidateList = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .getAllCandidateList()
      .then((response) => {
        dispatch(
          success(response.items, candidateConstants.GET_CANDIDATES_LIST)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const uploadCandidateExcel = (data, projectId = 0) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    candidateService
      .uploadCandidateExcel(data)
      .then((response) => {
        dispatch(getAllCandidate(gridData, projectId));
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const candidateActions = {
  getAllCandidate,
  getCandidateById,
  deleteCandidateById,
  createCandidate,
  updateCandidate,
  getAllCandidateList,
  uploadCandidateExcel
};
